// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import ConfigurationItemViewModel from "./configuration-item";
import BaoDialogViewModel from "./../factories/bao-dialog";
import TabPage from "./../factories/tab-page";
import AppTabController from "../services/app-tab-controller";

function PersonViewModel(tabPage) {
    var self = this;
    ConfigurationItemViewModel.call(this, tabPage);
    self.SelectedAccountAssignment = ko.observable();
    self.subscribe(self.SelectedAccountAssignment, function (newValue) {
        if (newValue != null) {
            if (self.AccountAssignmentTypeId() == null) {
                self.AccountAssignmentTypeId(newValue.AccountAssignmentTypeId);
                self.AccountAssignmentTypeName(newValue.AccountAssignmentTypeName);
            }
        }
    });
    self.CustomerName = ko.observable();
    self.subscribe(self.CustomerName, function (newValue) {
        if (newValue != null) {
            return Bao.post("ConfigurationItem/GetCustomer", JSON.stringify({
                id: self.CustomerId()
            }), function (result) {
                self.CompanyIdMandatory(result.IsCompanyIdMandatory);
            });
        }
    });
    self.GoToCustomer = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Customer");
        newTab.UrlData({
            id: self.CustomerId()
        });
        newTab.ObjectId(self.ParentConfigurationItemId());
        AppTabController.AddTab(newTab);
    };
    self.CompleteCheck = function () {
        var isComplete = true;
        if (self.ConfigurationItemTypeId() == null) {
            isComplete = false;
        }
        if (self.ConfigurationItemStatusId() == null) {
            isComplete = false;
        }
        if (self.CountryId() == null) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(self.Name1())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(self.CompanyCode()) && self.CompanyIdMandatory()) {
            isComplete = false;
        }
        if (self.ShiftGroupMandatory() && !self.ShiftGroupName()) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.ResetAccountAssignment = function (row) {
        self.AccountAssignment(null);
    };
    var base : any = {};
    base.loaded = self.loaded;
    self.ServiceProviderId = ko.observable();
    self.loaded = function () {
        if (tabPage.Object != null && tabPage.Object.ServiceProviderId != null) {
            self.ServiceProviderId(tabPage.Object.ServiceProviderId);
        }
        if (tabPage.Object != null && tabPage.Object.CustomerId != null) {
            self.CustomerId(tabPage.Object.CustomerId);
            self.CustomerName(tabPage.Object.CustomerName);
        }
        if (tabPage.Object != null && tabPage.Object.CountryId != null) {
            self.CountryId(tabPage.Object.CountryId);
            self.CountryName(tabPage.Object.CountryName);
        }
        base.loaded.call(self);
        tabPage.IsLoading(false);
    };
}
;
Bao.inherit(PersonViewModel, ConfigurationItemViewModel);
PersonViewModel.prototype.DeleteMessageKey = "msgDeletePerson";
PersonViewModel.prototype.RefreshUrl = "ConfigurationItem/GetPerson";
PersonViewModel.prototype.SaveUrl = "ConfigurationItem/SavePerson";
PersonViewModel.prototype.DeleteUrl = "ConfigurationItem/DeletePerson";
PersonViewModel.prototype.PermissionForward = "PersonMoveForwardSearch";
PersonViewModel.prototype.PermissionBackward = "PersonMoveBackwardSearch";
PersonViewModel.prototype.PermissionRefresh = "PersonRefresh";
PersonViewModel.prototype.PermissionSave = "PersonSave";
PersonViewModel.prototype.PermissionDelete = "PersonDelete";
PersonViewModel.prototype.ConfigurationItemTypeKeyCategory = "Person";
PersonViewModel.prototype.PermissionAuditTrail = "PersonAudit";
export default PersonViewModel;